import React, { FC, useMemo } from 'react';

import { EvBodyDefault, TEXT_COLOR } from '@evinced-private/ui-common';

import { getLastUpdatedText } from 'src/apps/dashboard/helpers/LastUpdatedHelper';

import { LastUpdatedProps } from './LastUpdated.types';

export const LastUpdated: FC<LastUpdatedProps> = ({
	firstUpdatedAt,
	secondUpdatedAt,
	dataAutomationId
}) => {
	const lastUpdatedText = useMemo(
		() => getLastUpdatedText(firstUpdatedAt, secondUpdatedAt),
		[firstUpdatedAt, secondUpdatedAt]
	);

	if (!lastUpdatedText) {
		return null;
	}

	return (
		<EvBodyDefault color={TEXT_COLOR.CONTENT_3} dataAutomationId={dataAutomationId}>
			{lastUpdatedText}
		</EvBodyDefault>
	);
};
